<!-- 产品中心 -->
<template>
    <div>
      <sub-banner id="id_about">
        <img src="../../assets/images/product/product_banner.jpg"/>
      </sub-banner>
      
      <!--案例中心 start--->
      <div class="product_example" v-show="false">
          <div class="product_contents">
              <div class="product_line_left"></div>
              <div class="product_title">案例展示</div>
              <div class="product_line_right"></div>
          </div>
          <div class="product_exhibition">
              <div class="exhibition_item two_transfer">
                  <div class="img_item"><img src="../../assets/images/product/product_one.png" /></div>
                  <div class="img_item"><img src="../../assets/images/product/product_two.png" /></div>
                  <div class="img_item"><img src="../../assets/images/product/product_three.png" /></div>
              </div>
              <div class="exhibition_item rightturnleft_one">
                  <div class="img_item"><img src="../../assets/images/product/product_four.png" /></div>
                  <div class="img_item"><img src="../../assets/images/product/product_five.png" /></div>
                  <div class="img_item"><img src="../../assets/images/product/product_six.png" /></div>
              </div>
          </div>
      </div>
      <!--案例中心 end--->
      <div class="product_center">
          <div class="product_center_info">
            <div class="product_contents">
                <div class="product_line_left"></div>
                <div class="product_title">{{$t('NavabarText.navbar_product')}}</div>
                <div class="product_line_right"></div>
            </div>
            <div class="product_type">
                <div  class="type_item" v-for="item in productTypeData" :key="item.id" @click="productTypeClick(item)" :class="active_type==item.code?'type_item_active':''" >
                    {{item.typeName}}
                </div>
               
            </div>
            <div class="product_detail_info">

                <div class="detail_item three_transfer" v-for="item in productData" :key="item.id" @click="openDetail(item)">
                    <div class="detail_item_img">
                        <img :src="item.mainImgUrl" />
                    </div>
                    <div class="detail_item_title">{{item.name}}</div>
                    <div class="detail_item_abstract">
                       {{item.brief_introduction}}
                    </div>
                </div> 
                <div class="detail_item_standing_position " v-for="(i,index) in standing_positon" :key="index"></div>
            </div>
            
            <div class="more_s">
             <div class="more_c">
                <div class="more_btn" @click="moreClick" v-if="moreShow">{{$t('indexText.more')}}</div>
             </div>
           </div>
          </div>
      </div>
    </div>
</template>

<script>
import {getProductTypeList,getProductList} from '../../service/service'
import SubBanner from "@/components/sub-banner"
export default {
  name: 'product',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-产品中心',
      metaName:'广州市熵达贸易有限公司-产品中心',
      metaContent:'广州市熵达贸易有限公司-产品中心',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司',   
      active_type:'cavity_mirror',
      productTypeData:[],
      productData:[],
      active_type_id:1,
      standing_positon:0,
      moreShow:false,
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
     moreClick(){
         this.getProductList(this.active_type_id,1,9999);
     },
     productTypeClick(val){
         this.active_type=val.code;
         this.active_type_id=val.id;
         this.getProductList(val.id,1,12);
     },
     async getProductTypeList(){
         let resp=await getProductTypeList(1,9999);
         if(resp){
             this.productTypeData=resp.data;
         }
     },
     async getProductList(typeId,pageNum,pageSize){
         let resp=await getProductList(typeId,pageNum,pageSize)
         if(resp){
             resp.data.map((v)=>{
                 v.mainImgUrl=process.env.BASE_IMG_URL+v.mainImgUrl;
             })
             this.productData=resp.data;
             let count=this.productData.length;
             if(count%3>0&&count>3){
               this.standing_positon=3-count%3;
             }else{
                 this.standing_positon=0;
             }
         }
     },
     openDetail(item){
         console.log('jin')
         this.$router.push({
            path: '/detail?id='+item.id
        });
     },
  },
  created () {

  },
  mounted () {
      this.getProductTypeList();
      this.getProductList(this.active_type_id,1,12);
  },
}
</script>
<style lang='scss' scoped>

 @import '../../assets/css/animation.css';
.product_example{
    width:100%;
    background-color: #fff;
    padding-bottom:134px;
    .product_exhibition{  
        width:70%;
        margin:auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        .exhibition_item{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .img_item{
                margin-left:10px;
                margin-bottom:10px;
                &:first-child{
                    margin-left:10px !important;
                }
                img{
                    width:100%;
                    height: 100%;
                }
            }
        }
    }

}
.product_contents{
        width:70%;
        margin:auto;
        padding-top:115px;
        padding-bottom:52px;
        display: flex;
        align-items: center;
        justify-content: center;
}
.product_line_left{
    width: 210px;
    // height: 0.5px;
    background-color: #2e2d32;
    border: solid 1px #4f7cbd;
    margin-right:28px;
}
.product_title{
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #4f7cbd;
}
.product_line_right{
    width: 210px;
    // height: 1px;
    background-color: #2e2d32;
    border: solid 1px #4f7cbd;
    margin-left:28px;
}
.product_center{
    background-color: #f8fbff;
    padding-top:55px; 
    padding-bottom:100px; 
    .product_center_info{
        
        .product_type{
            width:70%;
            margin:auto;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            .type_item{
                padding:10px 22px;
                // width:400px;
                font-size: 20px;
                margin-left:40px;
                cursor: pointer;
                margin-bottom:10px;
                &:first-child{
                    margin-left:0px !important;
                }
            }
            .type_item_active{
                background-color: #4f7cbd;
                border-radius: 26px;
                color:#ffffff;
            }
        }
        .product_detail_info{
            width:70%;
            margin:auto;
            margin-top:70px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            padding-bottom:68px; 
            .detail_item{
                margin-left:18px;
	            background-color: #ffffff;
                padding:18px 30px 30px 30px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                width:388px;
                margin-bottom: 15px;;
                .detail_item_img{
                    width: 100%;;
                    text-align: center;
                    height: 295px;
                    img{
                        width:100%;
                        height: 100%;
                    }
                }
                .detail_item_title{

                    font-size: 20px;
                    font-weight: bold;
                    color:#333333;
                    height: 40px;
                    margin-top:20px;
                }
                .detail_item_abstract{
                    margin-top:28px;
                    color:#999999;
                    font-size: 14px;
                    text-align: left;
                    position: relative;
                }
                .detail_item_abstract:before{
                    content:" ";
                    position:absolute;
                    left:0;
                    top:-15px;
                    width:100%;
                    height:1px;
                    transform:scaleY(.5);
                    background-color:#eeeeee;
                }
                &:first-child{
                    margin-left:0px !important;
                }
                &:nth-child(3n+1){
                    margin-left:0px;
                }
            }
            .detail_item_standing_position{
                margin-left:18px;
                padding:18px 30px 30px 30px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                width:388px;
                margin-bottom: 15px;;
            }
        }
    }
}


.more_s{
    width: 100%;
    text-align: center;
    .more_c{
        display: flex;
        justify-content: center;
        cursor: pointer;
        .more_btn{
            width: 147px;
            height: 49px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 25px;
            border: solid 2px #4f7cbd;
            color:#2750a2;
            font-size:20px;
            letter-spacing: 2px;
        }
        .more_btn:hover{
            background-color: #4f7cbd !important;
            color:#ffffff !important;
        }
    }
}

</style>




// WEBPACK FOOTER //
// src/view/product/index.vue